export default [
    {
        path: '/(uk/|ru/)?/iron-parks/cars/list',
        name: 'IronParksCarsList',
        component: () => import('../views/iron-parks/cars/list'),
        meta: {
            requiresAuth: true,
            title: 'Авто железного парка',
        },
    }, {
        path: '/(uk/|ru/)?/iron-parks/rent-active',
        name: 'IronParksCarsRentList',
        component: () => import('../views/iron-parks/cars/rentList'),
        meta: {
            requiresAuth: true,
            title: 'Аренда',
        },
    }, {
        path: '/(uk/|ru/)?/iron-parks/rent-active/:type',
        name: 'IronParksCarsTypeRentList',
        component: () => import('../views/iron-parks/cars/typeTables'),
        meta: {
            requiresAuth: true,
            title: 'Детализация',
        },
    }, {
        path: '/(uk/|ru/)?/iron-parks/rent-form/:driver_id/:park_id/:car_id',
        name: 'IronParksCarsRentForm',
        component: () => import('../views/iron-parks/cars/rentForm'),
        meta: {
            requiresAuth: true,
            title: 'Арендное авто',
        },
    }, {
        path: '/(uk/|ru/)?/iron-parks/cars/assign',
        name: 'IronParksCarsLAssign',
        component: () => import('../views/iron-parks/cars/assign/index.vue'),
        meta: {
            requiresAuth: true,
            title: 'Назначение железного парка',
        },
    }, {
        path: '',
        name: 'IronParksCarsIndex',
        component: () => import('../views/iron-parks/cars/edit/index'),
        meta: {
            requiresAuth: true,
            title: 'Редактирование',
            altNavSubMenuActive:'/iron-parks/cars/list',
        },
        children: [{
            path: '/(uk/|ru/)?/iron-parks/cars/edit',
            name: 'IronParksCarsEdit',
            component: () => import('../views/iron-parks/cars/edit/edit'),
            meta: {
                requiresAuth: true,
                title: 'Редактирование: Основной',
            },
        }, {
            path: '/(uk/|ru/)?/iron-parks/cars/edit/mileage',
            name: 'IronParksCarsMileage',
            component: () => import('../views/iron-parks/cars/edit/mileage'),
            meta: {
                requiresAuth: true,
                title: 'Редактирование: Пробег',
            },
        }, {
            path: '/(uk/|ru/)?/iron-parks/cars/edit/docs',
            name: 'IronParksCarsDocs',
            component: () => import('../views/iron-parks/cars/edit/docs'),
            meta: {
                requiresAuth: true,
                title: 'Редактирование: Пробег',
            },
        }, {
            path: '/(uk/|ru/)?/iron-parks/cars/edit/history',
            name: 'IronParksCarsHistory',
            component: () => import('../views/iron-parks/cars/edit/history'),
            meta: {
                requiresAuth: true,
                title: 'Редактирование: История',
            },
        }, {
            path: '/(uk/|ru/)?/iron-parks/cars/edit/payments',
            name: 'IronParksCarsPayments',
            component: () => import('../views/iron-parks/cars/edit/payments'),
            meta: {
                requiresAuth: true,
                title: 'Редактирование: Оплаты',
            },
        }, {
            path: '/(uk/|ru/)?/iron-parks/cars/edit/orders',
            name: 'IronParksCarsOrders',
            component: () => import('../views/iron-parks/cars/edit/orders'),
            meta: {
                requiresAuth: true,
                title: 'Редактирование: Поездки',
            },
        }, {
            path: '/(uk/|ru/)?/iron-parks/cars/edit/driver',
            name: 'IronParksCarsDriverDriver',
            component: () => import('../views/iron-parks/cars/edit/driver'),
            meta: {
                requiresAuth: true,
                title: 'Редактирование: Поездки',
            },
        },]
    }, {
        path: '/(uk/|ru/)?/iron-parks/drivers',
        name: 'IronParksDriversList',
        component: () => import('../views/iron-parks/drivers/list'),
        meta: {
            requiresAuth: true,
            title: 'Водители ',
        },
    }, {
        path: '/(uk/|ru/)?/iron-parks/drivers/editr',
        name: 'IronParksDriversEdit',
        component: () => import('../views/iron-parks/drivers/editr'),
        meta: {
            requiresAuth: true,
            title: 'Водитель железного парка',
            altNavSubMenuActive:'/iron-parks/drivers',
        },
    }, {
        path: '/(uk/|ru/)?/iron-parks/summary-cars',
        name: 'IronParksCarsList',
        component: () => import('../views/iron-parks/summaryCars'),
        meta: {
            requiresAuth: true,
            title: 'Сводная статистика по авто',
        },
    }, {
        path: '/(uk/|ru/)?/iron-parks/history-assignment',
        name: 'IronParksAssignmentHistory',
        component: () => import('../views/iron-parks/historyAssignment'),
        meta: {
            requiresAuth: true,
            title: 'История назначений',
        },
    }, {
        path: '/(uk/|ru/)?/iron-parks/orders-history',
        name: 'IronParksOrdersHistory',
        component: () => import('../views/iron-parks/ordersHistory'),
        meta: {
            requiresAuth: true,
            title: 'История поездок',
        },
    }, {
        path: '/(uk/|ru/)?/iron-parks/payments-history',
        name: 'IronParksPaymentsHistory',
        component: () => import('../views/iron-parks/paymentsHistory'),
        meta: {
            requiresAuth: true,
            title: 'Сводная статистика по авто',
        },
    }, {
        path: '/(uk/|ru/)?/iron-parks/list',
        name: 'IronParksPaymentsHistory',
        component: () => import('../views/iron-parks/list'),
        meta: {
            requiresAuth: true,
            title: 'Арендные авто',
        },
    }, {
        path: '',
        component: () => import('../views/iron-parks/paymentsList'),
        meta: {
            requiresAuth: true,
            title: 'Список оплат',
        },
        children: [{
            path: '/(uk/|ru/)?/iron-parks/payments-list',
            name: 'IronParksPaymentsListCurrent',
            component: () => import('../views/iron-parks/paymentsList/current'),
            meta: {
                requiresAuth: true,
                title: 'Список оплат: текущие',
            },
        }, {
            path: '/(uk/|ru/)?/iron-parks/payments-list/history',
            name: 'IronParksPaymentsListHistory',
            component: () => import('../views/iron-parks/paymentsList/history'),
            meta: {
                requiresAuth: true,
                title: 'Список оплат: история',
            },
        }]
    }, {
        path: '/(uk/|ru/)?/iron-parks/assign-history',
        name: 'IronParksAssignHistory',
        component: () => import('../views/iron-parks/assignHistory'),
        meta: {
            requiresAuth: true,
            title: 'История назначений',
        },
    }, {
        path: '/(uk/|ru/)?/iron-parks/fines',
        name: 'IronParksFines',
        component: () => import('../views/iron-parks/fines'),
        meta: {
            requiresAuth: true,
            title: 'История назначений',
        },
    }, {
        path: '/(uk/|ru/)?/iron-parks/mutual-settlement',
        name: 'mutualSettlement',
        component: () => import('../views/iron-parks/mutualSettlement/list'),
        meta: {
            activeSideIcon:'#icon-rent-car',
            requiresAuth: true,
            title: 'Взаиморасчёты',
        },
    }, {
        path: '/(uk/|ru/)?/iron-parks/mutual-settlement/detail',
        name: 'mutualSettlementDetail',
        component: () => import('../views/iron-parks/mutualSettlement/detail'),
        meta: {
            activeSideIcon:'#icon-rent-car',
            requiresAuth: true,
            title: 'Взаиморасчёты детализация',
        },
    },
]
